// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createStoreQuotes = (client) => ({
    /**
     * `POST /store/quotes/:id/accept`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreQuotesIdAccept
     * @source packages/medusa-plugin-quote-management/src/api/store/quotes/[id]/accept/route.ts
     */
    accept: (id, body, query, headers) => client.fetch(buildPath("/store/quotes/:id/accept", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /store/quotes`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/store/quotes/route.ts
     */
    create: (body, query, headers) => client.fetch("/store/quotes", { method: "POST", body, query, headers }),
    /**
     * `POST /store/quotes/:id/messages`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/store/quotes/[id]/messages/route.ts
     */
    createMessage: (id, body, query, headers) => client.fetch(buildPath("/store/quotes/:id/messages", [id]), { method: "POST", body, query, headers }),
    /**
     * `GET /store/quotes`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/store/quotes/route.ts
     */
    list: (query, headers) => client.fetch("/store/quotes", { method: "GET", query, headers }),
    /**
     * `GET /store/quotes/:id/preview`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/store/quotes/[id]/preview/route.ts
     */
    preview: (id, query, headers) => client.fetch(buildPath("/store/quotes/:id/preview", [id]), { method: "GET", query, headers }),
    /**
     * `POST /store/quotes/:id/reject`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/store/quotes/[id]/reject/route.ts
     */
    reject: (id, body, query, headers) => client.fetch(buildPath("/store/quotes/:id/reject", [id]), { method: "POST", body, query, headers }),
    /**
     * `GET /store/quotes/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/store/quotes/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/store/quotes/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /store/quotes/:id/pdf`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreQuoteGetPdf
     * @source packages/medusa-plugin-quote-management/src/api/store/quotes/[id]/pdf/route.ts
     */
    retrievePdf: (id, query, headers) => client.fetch(buildPath("/store/quotes/:id/pdf", [id]), { method: "GET", query, headers }),
});
//# sourceMappingURL=quotes.js.map